<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="mall_mypageWrap">
      <div class="mall_flexWrap">
        <div class="mallMy_LeftWrap">
          <p class="mallMy_TitName">
            <span>{{sessionData.customer.customer_name}}</span> <!-- 님 : 비회원 주문 조회할 때 이름없이 "님"글자만 떠서 주석처리 -->
          </p>
          <ul class="mallMy_TitList">
            <li @click="setMyID(1)" :class="{ 'myPageActive': 1 === statusData.myID }">
              <a>주문내역</a>
            </li>
            <li @click="setMyID(2)" :class="{ 'myPageActive': 2 === statusData.myID }">
              <a>회원정보</a>
            </li>
            <li>
              <a v-on:click="logout">로그아웃</a>
            </li>
          </ul>
        </div>
        <div class="mallMy_RightWrap">
          <div class="mallMy_myContWrap" v-if="statusData.myID === 1">
            <h2>주문 내역</h2>
            <div>
              <div class="mallMy_oL_tabs">
                <div class="mallMy_oL_tabsMain">
                  <button
                    :class="{ mytabAct: statusData.mainTab === 'orders' }"
                    @click="setMainTab('orders')"
                  >
                    <span>주문내역<em></em></span>
                  </button>
                  <button
                    :class="{ mytabAct: statusData.mainTab === 'returns' }"
                    @click="setMainTab('returns')"
                  >
                    취소/반품/교환
                  </button>
                </div>
                <div class="mallMy_oL_tabsSub">
                  <button
                    :class="{ mytabAct: statusData.currentTab === 'tab1' }"
                    @click="setTab('tab1')"
                  >
                    1개월
                  </button>
                  <button
                    :class="{ mytabAct: statusData.currentTab === 'tab2' }"
                    @click="setTab('tab2')"
                  >
                    3개월
                  </button>
                  <button
                    :class="{ mytabAct: statusData.currentTab === 'tab3' }"
                    @click="setTab('tab3')"
                  >
                    6개월
                  </button>
                  <button
                    :class="{ mytabAct: statusData.currentTab === 'tab4' }"
                    @click="setTab('tab4')"
                  >
                    기간 설정
                  </button>
                </div>
                <div v-if="statusData.currentTab === 'tab4' && statusData.myID === 1" class="mallMy_oL_tabsSetting"> <!-- 기간설정의 달력 order-period-setting-->
                  <input
                    type="date"
                    v-model="statusData.startDate"
                    placeholder="시작 날짜"
                  />
                  ~
                  <input
                    type="date"
                    v-model="statusData.endDate"
                    placeholder="종료 날짜"
                  />
                  <button @click="searchByDate">조회</button>
                </div>
              </div>

              <div class="mallMy_oL_dataWrap"> <!-- 주문내역 데이타 -->
                <!-- 데이타 있을 때 -->
                <div v-if="statusData.myID === 1 && statusData.orderData.length !== 0">
                  <div class="mallMy_oL_dataYesBox" v-for="order_item in statusData.orderData" :key="order_item.order_ID">
                    <div class="mallMy_oL_dataYB_date">
                      <span>{{order_item.order_registe}}</span> <em>(주문번호 {{order_item.order_ID.toLocaleString()}})</em>
                    </div>
                    <div class="mallMy_oL_dataYB_pdInfoBox" v-for="(item, index) in order_item.buyListData" :key="index">
                      <div class="mallMy_oL_dataYB_deliveryStatus">
                        {{ getDeliveryStatus(item.buy_list.delivery_progress) }}
                      </div>
                      <div class="mallMy_oL_pdInfo">
                        <div class="mallMy_oL_pdInfo_pd">
                          <p>{{item.product.product_kor_name}}</p>
                          <p class="mallMy_oL_pdInfo_pdPrice" v-if="order_item.order_pay_status !== 3">
                            <template v-if="item.product.product_discount <= 0">
                              {{formatPrice(item.product.product_sale_price)}}원 ({{item.buy_list.selling_count}}개)
                            </template>
                            <template v-else>
                              <div>
                                <p class="dc_origin">KRW {{formatPrice(item.product.product_sale_price)}}</p>
                                <p class="dc_dcPrice">KRW {{formatPrice(item.product.product_discount)}} ({{item.buy_list.selling_count}}개)</p>
                              </div>
                            </template>
                          </p>
                          <div class="mallMy_oL_pdInfo_option" v-if="item.product_option.length && order_item.order_pay_status !== 3">
                            <div v-if="item.buy_list.product_group_option_name">
                              <p>
                                [{{item.buy_list.product_group_option_title}}] :
                                {{item.buy_list.product_group_option_name}}
                              </p>
                            </div>
                            <div
                              v-for="(option_item, option_index) in item.product_option"
                              :key="option_index">
                              <p>
                                [옵션{{option_index+1}} :
                                {{option_item.product_option_name}}]
                                {{option_item.product_option_list_name}}
                                (KRW {{String(option_item.product_option_list_plus_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}})
                              </p>
                              </div>
                            <p v-if="item.buy_list.product_note">
                              [{{item.buy_list.product_note_title}}] {{item.buy_list.product_note}}
                            </p>
                          </div>
                        </div>
                        <div class="mallMy_oL_pdInfo_img">
                          <img src="/mnt/data/image.png" alt="Product Image" />
                        </div>
                      </div>

                      <div class="mallMy_oL_pdInfo_totalPrice" v-if="order_item.order_pay_status !== 3">
                        <p v-if="item.buy_list.sellingDiscountPrice === 0">KRW {{String(item.buy_list.sellingPrice * item.buy_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</p>
                        <p v-else>KRW {{String(item.buy_list.sellingDiscountPrice * item.buy_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</p>
                      </div>
                    </div>

                    <div class="mallMy_oL_payStatusBox">
                      <p class="mallMy_oL_pSB_tit">결제 정보</p>
                      <div class="mallMy_oL_pSB_info">
                        <div class="mallMy_oL_pSB_status">
                          <div>{{order_item.order_pay_status_name}}</div>
                          <div>
                            <p v-if="order_item.order_pay_status === 1">
                              (KRW {{String(order_item.order_payment_amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}})
                            </p>
                            <p v-if="order_item.order_pay_status === 2">
                              (KRW {{String(order_item.order_expected_payment_amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}})
                            </p>
                          </div>
                        </div>

                        <div class="mallMy_oL_pSB_btns">
                          <button
                            v-if='
                              order_item.order_check_request_status === 0 &&
                              order_item.order_method === 0 &&
                              order_item.order_cancle_request_status === 0
                            '
                            @click="orderCheck(order_item.order_ID)"
                          >
                            결제확인요청
                          </button>
                          <p v-if='order_item.order_check_request_status !== 0'>
                            {{order_item.order_check_request_status_name}}
                          </p>
                        </div>

                        <div class="mallMy_oL_pSB_btns">
                          <button
                            v-if='
                              order_item.order_cancle_request_status === 0
                            '
                            @click="orderCancle(order_item.order_ID)"
                            >
                            주문취소요청
                          </button>
                          <p v-if='order_item.order_cancle_request_status !== 0'>
                            {{order_item.order_cancle_request_status_name}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 데이타 없을 때 -->
                <div class="mallMy_oL_dataWrap"  v-if="statusData.myID === 1 && statusData.orderData.length === 0"> <!-- 데이터 없을때 화면 표시 -->
                  <div class="mallMy_oL_dataNoBox">
                    주문내역이 없습니다.
                  </div>
                </div>
                <!-- 주문내역 -->
              </div>
            </div>
          </div>

          <!-- 회원정보 -->
          <div class="mallMy_myContWrap" v-if="statusData.myID === 2">
            <h2>회원정보수정</h2>
            <div>
              <table class="mallMy_myInfoTable" cellpadding="0" cellspacing="0" summary="회원정보수정">
                <caption>회원정보수정</caption>
                <colgroup>
                  <col width="20%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">
                      <label for = 'customer_division_name'>가입구분</label>
                    </th>
                    <td>
                      <span class="fB600">{{statusData.customerDivisionName}}</span>
                    </td>
                  </tr>
                  <tr v-if="statusData.customerDivision === 1">
                    <th scope="row">
                      <label for = 'customer_login_ID'>아이디</label>
                    </th>
                    <td>
                      <span class="fB600">{{statusData.customerLoginID}}</span>
                    </td>
                  </tr>
                  <tr v-if="statusData.customerDivision === 1">
                    <th>
                      <label for = 'customer_password'>비밀번호</label>
                    </th>
                    <td>
                      <input
                        type = "password"
                        id = 'customer_password'
                        v-model="formData.customerPassword"
                        maxlength="20"
                      >
                      <p class="mallMy_myIT_subTxt">* 영문, 숫자, 특수문자를 혼합하여 8~20자까지 입력</p>
                    </td>
                  </tr>
                  <tr v-if="statusData.customerDivision === 1">
                    <th>
                      <label for = 'customer_password_check'>비밀번호 확인</label>
                    </th>
                    <td>
                      <input
                        type = "password"
                        id = 'customer_password_check'
                        v-model="formData.customerPasswordCheck"
                        maxlength="20"
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label for = 'customer_name'>이름 <span class="pointTextRed">*</span></label>
                    </th>
                    <td>
                      <input
                        type = "text"
                        id = 'customer_name'
                        v-model="formData.customerName"
                        maxlength="10"
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label for = 'customer_phone_number'>휴대폰 번호 <span class="pointTextRed">*</span></label>
                    </th>
                    <td>
                      <input
                        type = "text"
                        id = 'customer_phone_number'
                        v-model="formData.customerPhoneNumber"
                        @input="formatPhoneNumber"
                        maxlength="13"
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label for = 'customer_email'>이메일 <span class="pointTextRed">*</span></label>
                    </th>
                    <td>
                      <input
                        type = "text"
                        id = 'customer_email'
                        v-model="formData.customerEmail"
                        maxlength="50"
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label for = 'customer_gender'>성별 <span class="pointTextRed">*</span></label>
                    </th>
                    <td>
                      <select
                        type = "text"
                        id = 'customer_gender'
                        v-model="formData.customerGender"
                      >
                        <option value = '1'>남</option>
                        <option value = '2'>여</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label for = 'customer_zip_code'>주소 <span class="pointTextRed">*</span></label>
                    </th>
                    <td>
                      <div class="mallMy_mIT_address">
                        <div class="mallMy_mIT_addressZipcode">
                          <input
                            type = "text"
                            id = 'customer_zip_code'
                            v-model="formData.customerZipCode"
                            v-on:click="search_address"
                            maxlength="10"
                            readonly
                          >
                          <button
                            v-on:click="search_address"
                          >
                            주소검색
                          </button>
                        </div>
                        <input
                          type = "text"
                          id = 'customer_road_address'
                          v-model="formData.customerRoadAddress"
                          maxlength="150"
                          readonly
                          v-on:click="search_address"
                        >
                        <input
                          type = "text"
                          id = 'customer_detail_address'
                          v-model="formData.customerDetailAddress"
                          maxlength="150"
                          placeholder="상세주소를 입력해주세요."
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      마케팅 동의
                    </th>
                    <td>
                      <div class="mallMy_mIT_checkBox">
                        <input
                          type = "checkbox"
                          id = 'customer_marketing_status'
                          v-model="formData.customerMarketingStatus"
                        >
                        <label class="hp_tableInputCheck_label" for = 'customer_marketing_status'> 마케팅 수신에 동의합니다</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="mallMy_mIT_btns">
                <button @click="updateCustomer">수정하기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_session_customer,
  update_recent_buy_list,
  get_order_non_member,
  get_order_customer_ID,
  update_order_cancle_request_status,
  update_order_check_request_status,
  get_customer_one,
  update_customer_homepage,
  delete_session_customer
} from '../../ETC/Axios.vue'

export default {
  name: 'My',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    const today = new Date()
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    const oneMonthAgo = new Date()
    oneMonthAgo.setMonth(today.getMonth() - 1)
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        myID: 1,
        mainTab: 'orders', // 기본 탭은 '주문내역'
        currentTab: 'tab1',
        orderData: [],
        startDate: formatDate(oneMonthAgo),
        endDate: formatDate(today),
        customerDivision: 1,
        customerDivisionName: '자체가입',
        customerLoginID: ''
      }),
      formData: ref({
        customerPassword: '',
        customerPasswordCheck: '',
        customerName: '',
        customerPhoneNumber: '',
        customerEmail: '',
        customerGender: '',
        customerZipCode: '',
        customerRoadAddress: '',
        customerDetailAddress: '',
        customerBigArea: '',
        customerSmallArea: '',
        customerMarketingStatus: false
      })
    }
  },
  methods: {
    logout: function () {
      delete_session_customer().then(result => {
        window.location.href = '/'
      })
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    change_buy_list: function (result) {
      result.forEach((result_element, index) => {
        result_element.buyListData = []
        result_element.totalsellingPrice = 0
        if (JSON.parse(result_element.order_buy_list).length !== 0) {
          update_recent_buy_list(result_element.order_buy_list).then(result_recent_buy_list => {
            result_element.buyListData = result_recent_buy_list
            result_element.totalsellingPrice = 0
            if (result_recent_buy_list !== '') {
              result_recent_buy_list.forEach((element) => {
                if (element.buy_list.sellingDiscountPrice !== 0) {
                  result_element.totalsellingPrice += element.buy_list.sellingDiscountPrice * element.buy_list.selling_count
                } else {
                  result_element.totalsellingPrice += element.buy_list.sellingPrice * element.buy_list.selling_count
                }
              })
            }
          })
        }
        index++
      })
      this.statusData.orderData = result
    },
    change_customer: function (customer_ID) {
      get_customer_one(
        customer_ID
      ).then(result => {
        this.statusData.customerDivision = result[0].customer_division
        this.statusData.customerDivisionName = result[0].customer_division_name
        this.statusData.customerLoginID = result[0].customer_login_ID
        this.formData.customerName = result[0].customer_name
        this.formData.customerPhoneNumber = result[0].customer_phone_number
        this.formData.customerEmail = result[0].customer_email
        this.formData.customerGender = result[0].customer_gender
        this.formData.customerZipCode = result[0].customer_zip_code
        this.formData.customerRoadAddress = result[0].customer_road_address
        this.formData.customerDetailAddress = result[0].customer_detail_address
        this.formData.customerBigArea = result[0].customer_big_area
        this.formData.customerSmallArea = result[0].customer_small_area
        this.formData.customerMarketingStatus = result[0].customer_marketing_status
      })
    },
    getDeliveryStatus (progress) {
      const statusMap = {
        0: '배송 준비 중',
        1: '배송 중',
        2: '배송 완료',
        3: '배송 취소'
      }
      return statusMap[progress] || '알 수 없음'
    },
    fetchOrderData () {
      if (this.sessionData.customer === '') {
        get_order_non_member(
          this.$route.query.orderReceiveName,
          this.$route.query.orderPhoneNumber,
          this.statusData.startDate,
          this.statusData.endDate,
          this.statusData.mainTab
        ).then((result) => {
          this.change_buy_list(result)
        })
      } else {
        get_order_customer_ID(
          this.sessionData.customer.customer_ID,
          this.statusData.startDate,
          this.statusData.endDate,
          this.statusData.mainTab
        ).then((result) => {
          this.change_buy_list(result)
        })
      }
    },
    setMainTab (tab) {
      this.statusData.mainTab = tab
      this.fetchOrderData()
    },
    setTab (tab) {
      const today = new Date()
      this.statusData.currentTab = tab
      if (tab === 'tab1') {
        const oneMonthAgo = new Date()
        oneMonthAgo.setMonth(today.getMonth() - 1)
        this.statusData.startDate = this.formatDate(oneMonthAgo)
        this.statusData.endDate = this.formatDate(today)
        this.fetchOrderData()
      } else if (tab === 'tab2') {
        const threeMonthsAgo = new Date()
        threeMonthsAgo.setMonth(today.getMonth() - 3)
        this.statusData.startDate = this.formatDate(threeMonthsAgo)
        this.statusData.endDate = this.formatDate(today)
        this.fetchOrderData()
      } else if (tab === 'tab3') {
        const sixMonthsAgo = new Date()
        sixMonthsAgo.setMonth(today.getMonth() - 6)
        this.statusData.startDate = this.formatDate(sixMonthsAgo)
        this.statusData.endDate = this.formatDate(today)
        this.fetchOrderData()
      }
    },
    searchByDate () {
      if (this.statusData.currentTab === 'tab4') {
        this.fetchOrderData()
      }
    },
    orderCancle (order_ID) {
      if (confirm('주문취소를 요청하시겠습니까?')) {
        update_order_cancle_request_status(
          order_ID,
          '1'
        ).then((result) => {
          const orderItem = this.statusData.orderData.find(
            (item) => item.order_ID === order_ID
          )
          if (orderItem) {
            orderItem.order_cancle_request_status = 2
            orderItem.order_cancle_request_status_name = '주문취소요청 처리중'
          }
          alert('주문취소요청이 완료되었습니다.')
        })
      }
    },
    orderCheck (order_ID) {
      if (confirm('결제확인을 요청하시겠습니까?')) {
        update_order_check_request_status(
          order_ID,
          '1'
        ).then((result) => {
          const orderItem = this.statusData.orderData.find(
            (item) => item.order_ID === order_ID
          )
          if (orderItem) {
            orderItem.order_check_request_status = 2
            orderItem.order_check_request_status_name = '결제확인요청 처리중'
          }
          alert('결제확인요청이 완료되었습니다.')
        })
      }
    },
    setMyID (id) {
      this.statusData.myID = id
      if (id !== 1 && this.sessionData.customer === '') {
        window.location.href = '/Login'
      } else if (id === 2) {
        this.change_customer(this.sessionData.customer.customer_ID)
      } else if (id === 1) {
        this.fetchOrderData()
      }
    },
    search_address: function () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.formData.customerZipCode = data.zonecode
          this.formData.customerRoadAddress = data.roadAddress === '' ? data.autoRoadAddress : data.roadAddress
          this.formData.customerDetailAddress = data.buildingName
          this.formData.customerBigArea = data.sido
          this.formData.customerSmallArea = data.sigungu
        }
      }).open()
    },
    formatPhoneNumber (event) {
      let input = event.target.value.replace(/\D/g, '').substring(0, 11)
      let formatted = ''
      if (input.startsWith('010')) {
        if (input.length <= 3) {
          formatted = input
        } else if (input.length <= 7) {
          formatted = input.replace(/(\d{3})(\d{1,4})/, '$1-$2')
        } else {
          formatted = input.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3')
        }
      } else {
        formatted = input.substring(0, 3)
      }
      this.formData.customerPhoneNumber = formatted
    },
    updateCustomer () {
      if (this.formData.customerPassword) {
        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
        if (!passwordRegex.test(this.formData.customerPassword)) {
          alert('비밀번호는 최소 8자리이며, 숫자와 특수문자를 1회 이상 포함해야 합니다.')
          return
        }
        if (this.formData.customerPassword !== this.formData.customerPasswordCheck) {
          alert('비밀번호와 비밀번호 확인이 일치하지 않습니다.')
          return
        }
      }
      const nameRegex = /^[가-힣a-zA-Z]{2,}$/
      if (!nameRegex.test(this.formData.customerName)) {
        alert('이름은 최소 2자리의 한글 또는 영문만 입력할 수 있습니다.')
        return
      }
      const phoneRegex = /^\d{3}-\d{3,4}-\d{4}$/
      if (!phoneRegex.test(this.formData.customerPhoneNumber)) {
        alert('휴대폰 번호는 010-1234-5678 형식으로 입력해주세요.')
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.formData.customerEmail)) {
        alert('이메일 형식이 올바르지 않습니다.')
        return
      }
      update_customer_homepage(
        this.sessionData.customer.customer_ID,
        this.formData.customerPassword,
        this.formData.customerName,
        this.formData.customerPhoneNumber,
        this.formData.customerEmail,
        this.formData.customerGender,
        this.formData.customerZipCode,
        this.formData.customerRoadAddress,
        this.formData.customerDetailAddress,
        this.formData.customerBigArea,
        this.formData.customerSmallArea,
        this.formData.customerMarketingStatus
      ).then(result => {
        alert('정보가 수정되었습니다.')
      }).catch(() => {
        alert('정보 수정 중 오류가 발생했습니다.')
      })
    }
  },
  mounted () {
    get_session_customer().then(result_session => {
      this.sessionData.customer = result_session
      this.statusData.myID = +this.$route.query.myID
      if (Number(this.$route.query.myID) === 1) {
        if (result_session === '') {
          get_order_non_member(
            this.$route.query.orderReceiveName,
            this.$route.query.orderPhoneNumber,
            this.statusData.startDate,
            this.statusData.endDate,
            this.statusData.mainTab
          ).then(result => {
            this.change_buy_list(result)
          })
        } else {
          this.sessionData.customer = result_session
          get_order_customer_ID(
            result_session.customer_ID,
            this.statusData.startDate,
            this.statusData.endDate,
            this.statusData.mainTab
          ).then(result => {
            this.change_buy_list(result)
          })
        }
      } else if (Number(this.$route.query.myID) === 2 && result_session !== '') {
        this.change_customer(result_session.customer_ID)
      } else {
        if (result_session === '') {
          window.location.href = '/Login'
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/My/My.vue